import { render } from "./error.vue?vue&type=template&id=bf05ac1e&scoped=true"
const script = {}

import "./error.vue?vue&type=style&index=0&id=bf05ac1e&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/mysystem_data_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf05ac1e"]])

export default __exports__